import {
  FETCH_LICENCIA_INFO,
  SEND_LICENCIA,
  EDIT_LICENCIA,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
  FETCHING_LICENCIA,
  FETCHED_LICENCIA,
  SUBMITED_LICENCIA,
  SUBMIT_LICENCIA_ERROR,
  RESET_LICENCIA_SUBMIT,
  RESET_LICENCIA_PROCESSING,
  STARTED_LICENCIA_PROCESSING,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  submited_licencia: false,
  processing_licencia: false,
  loading_licencia: false,
};

const getters = {
  is_loading() {
    return state.loading_licencia;
  },
  licencia_submited() {
    return state.submited_licencia;
  },
  licencia_processing() {
    return state.processing_licencia;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
};

const actions = {
  [FETCH_LICENCIA_INFO](context, id) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_LICENCIA);
      ApiService.query(`vehiculos/licencia/${id}`)
        .then(({ data }) => {
          context.commit(FETCHED_LICENCIA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_LICENCIA);
        });
    });
  },
  [SEND_LICENCIA](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('vehiculos/licencia', data)
        .then(({ data }) => {
          context.commit(SUBMITED_LICENCIA, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_LICENCIA_ERROR, [response.data.message]);
        });
    });
  },
  [EDIT_LICENCIA](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`vehiculos/licencia/update/${data.get('licencia_id')}`, data)
        .then(({ data }) => {
          context.commit(SUBMITED_LICENCIA, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_LICENCIA_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [FETCHING_LICENCIA](state) {
    state.loading_licencia = true;
  },
  [FETCHED_LICENCIA](state) {
    state.loading_licencia = false;
  },
  [SUBMITED_LICENCIA](state, data) {
    state.submited_licencia = true;
    state.alert = true;
    state.alertMessage = 'Licencia Enviado Correctamente';
    state.alertType = 'success';
    console.log(state);
  },
  [SUBMIT_LICENCIA_ERROR](state, data) {
    state.processing_licencia = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_LICENCIA_SUBMIT](state) {
    state.submited_licencia = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_LICENCIA_PROCESSING](state) {
    state.processing_licencia = false;
  },
  [STARTED_LICENCIA_PROCESSING](state) {
    state.processing_licencia = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
